/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Meta_DescriptionInputs */

const es_marketplace_seo_galicia_meta_description = /** @type {(inputs: Marketplace_Seo_Galicia_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler de barcos en Galicia y Rías Baixas: excursiones a Isla Sálvora, Islas Cíes desde Vigo o Sanxenxo, barco mejillones y más. Reserva con armadores locales.`)
};

const gl_marketplace_seo_galicia_meta_description = /** @type {(inputs: Marketplace_Seo_Galicia_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiro de barcos en Galicia e Rías Baixas: excursiones á Illa Sálvora, Illas Cíes dende Vigo ou Sanxenxo, barco mexillóns e máis. Reserva con armadores locais.`)
};

const en_marketplace_seo_galicia_meta_description = /** @type {(inputs: Marketplace_Seo_Galicia_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat rental in Galicia and Rías Baixas: trips to Sálvora island, Cíes from Vigo or Sanxenxo, mussel boat tours and more. Book with local owners.`)
};

/**
* | output |
* | --- |
* | "Boat rental in Galicia and Rías Baixas: trips to Sálvora island, Cíes from Vigo or Sanxenxo, mussel boat tours and more. Book with local owners." |
*
* @param {Marketplace_Seo_Galicia_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_meta_description = /** @type {((inputs?: Marketplace_Seo_Galicia_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_meta_description(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_meta_description(inputs)
	return es_marketplace_seo_galicia_meta_description(inputs)
});